export const copyImageToClipboard = async (blob: Blob): Promise<void> => {
  if (!navigator.clipboard?.write) {
    throw new Error("Ваш браузер не поддерживает копирование изображений");
  }

  if (!blob.type) {
    throw new Error("Невозможно определить тип изображения");
  }

  try {
    await navigator.clipboard.write([
      new ClipboardItem({ [blob.type]: blob })
    ]);
  } catch (err) {
    // Пробрасываем ошибку наверх для обработки
    throw err;
  }
};